import { CapaConnectMyFile } from '@generated/graphql';
import { useState } from 'react';

const useSelectFile = (): [
  Omit<CapaConnectMyFile, 'fileExtension'>[],
  (file: Omit<CapaConnectMyFile, 'fileExtension'>) => void
] => {
  const [selectedFile, setSelectedFile] = useState<
    Omit<CapaConnectMyFile, 'fileExtension'>[]
  >([]);

  const onSelect = (file: Omit<CapaConnectMyFile, 'fileExtension'>) => {
    const isDuplicated = selectedFile.some(
      (selected) => selected.fileId === file.fileId
    );

    if (isDuplicated) {
      setSelectedFile(
        selectedFile.filter((selected) => selected.fileId !== file.fileId)
      );
    } else {
      setSelectedFile([...selectedFile, file]);
    }
  };
  return [selectedFile, onSelect];
};

export default useSelectFile;
